import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-caso-uso',
  templateUrl: './caso-uso.component.html',
  styleUrls: ['./caso-uso.component.css']
})
export class CasoUsoComponent implements OnInit, OnDestroy {
  isDarkMode = true;
  private themeObserver?: MutationObserver;

  constructor() { }

  ngOnInit(): void {
    this.detectTheme();
    this.observeThemeChanges();
  }

  ngOnDestroy(): void {
    if (this.themeObserver) {
      this.themeObserver.disconnect();
    }
  }

  private detectTheme() {
    this.isDarkMode = document.body.classList.contains('dark-theme');
  }

  private observeThemeChanges() {
    this.themeObserver = new MutationObserver(() => {
      this.detectTheme();
    });
    
    this.themeObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
}
